import { useBrandCookie } from 'hooks/helpers/useBrandCookie'
import { useAppSelector } from 'redux/store'

export const useIsMedlevePage = (): boolean => {
  const { profile } = useAppSelector((state) => state.auth)

  const hasCookie = useBrandCookie('isMedleveAddress')
  const isMedleveUser = profile?.partnerName?.toLowerCase() === 'medleve'

  return Boolean(hasCookie || isMedleveUser)
}
